export interface QuestionRequiredInterface{
    key: Number;
    value: String;
}

export const QuestionRequired : QuestionRequiredInterface[] = [
    {key: 0, value: 'SIM'},
    {key: 1, value: 'NÃO'},
]